import React from 'react';
import config from 'src/config';
import { ArrowUpToLine } from 'lucide-react';
import Modal from '../modal/Modal';
import { PrimaryButton } from '../button/Button';
import CMSArticle from '../cms-article/CMSArticle';

type UploadDataModalProps = {
    onClose: () => void;
};

const UploadDataModal = ({ onClose }: UploadDataModalProps) => {
    return (
        <Modal
            onClose={onClose}
            dismissOnClickOutside={true}
            classNames={{
                body: 'w-[625px]',
            }}
        >
            <div className='flex flex-col gap-3'>
                <div className='flex gap-3 text-primary text-xl items-center'>
                    <span className='border border-primary rounded-full p-1'>
                        <ArrowUpToLine />
                    </span>
                    Import Data (beta)
                </div>
                <div className='text-sm'>
                    <CMSArticle slug='import-third-party-data-popup' />
                </div>
                <PrimaryButton
                    className='w-fit place-self-end'
                    onClick={() => {
                        const newWindow = window.open(config.uploadDataFormUrl, '_blank', 'noopener,noreferrer');
                        if (newWindow) {
                            newWindow.opener = null;
                        }
                    }}
                >
                    Register now for early access
                </PrimaryButton>
            </div>
        </Modal>
    );
};

export default UploadDataModal;
